import React, { Fragment } from 'react'

const Credit = () => {
  return <Fragment>Credit</Fragment>
}

export default Credit
